<template>
    <div>
        <v-row align="end" class="mt-5">
            <v-col cols="12" md="8">
                <div class="text-welcome">
                    Welcome ; (bienvenido):
                    <div class="subtext-welcome">
                        {{ accountName }}
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="4">
                {{ clientName }}
            </v-col>
        </v-row>

        <!-- NEED CHANGE PASSWORD -->
        <v-row v-if="needChangePassword" class="mt-5">
            <v-col cols="12">
                <v-alert type="info" color="accent" dense border="left"
                    @click.native="$router.push({ name: 'change-password' })" style="cursor:pointer !important;">
                    Aún no actualiza su contraseña.
                </v-alert>
            </v-col>
        </v-row>

        <!-- REPORTS -->
        <list-expense-reports isHomeView :userId="userId" :clientId="clientId" />
    </div>
</template>

<script>
import ListExpenseReports from '../expenseReports/ListExpenseReports.vue'
export default {
    components: { ListExpenseReports },
    computed: {
        accountName() {
            console.log('this.account',this.account);
            return this.account?.name || 'n/d'
        },
        needChangePassword() {
            return !!(this.account?.need_change_password)
        },
        userId() {
            return this.account?.id || null
        },
        clientName() {
            return this.account?.client?.name || ''
        },
        clientId() {
            return this.account?.clients?.[0]?.id || null
        }
    }
}
</script>

<style scoped>
.text-welcome {
    font-size: 20px;
    color: black;
}

.subtext-welcome {
    font-size: 25px;
    font-weight: bold;
    color: var(--v-primary-base);
    border-bottom: 3px solid var(--v-primary-base);
    width: fit-content;
}
</style>